import { render, staticRenderFns } from "./PzFormFlujoTemplate.vue?vue&type=template&id=7f99c262&scoped=true&"
import script from "./PzFormFlujoTemplate.vue?vue&type=script&lang=js&"
export * from "./PzFormFlujoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f99c262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f99c262')) {
      api.createRecord('7f99c262', component.options)
    } else {
      api.reload('7f99c262', component.options)
    }
    module.hot.accept("./PzFormFlujoTemplate.vue?vue&type=template&id=7f99c262&scoped=true&", function () {
      api.rerender('7f99c262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Templates/PzFormFlujoTemplate.vue"
export default component.exports